export default __webpack_public_path__ + "static/media/caret-right.2ac05f6f.svg";